import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "card-px text-left py-0 my-10" }
const _hoisted_4 = {
  key: 0,
  class: "fs-1x fw-bolder mb-10"
}
const _hoisted_5 = {
  key: 1,
  class: "fs-1x fw-bolder mb-10"
}
const _hoisted_6 = { class: "text-gray-600 fs-6 fw-bold mb-5" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "round3" }, [
      /*#__PURE__*/_createTextVNode(" Los campos marcados con ("),
      /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, " * "),
      /*#__PURE__*/_createTextVNode(") son de llenado obligatorio. ")
    ])
  ])
], -1)
const _hoisted_10 = {
  class: "stepper stepper-links d-flex flex-column",
  id: "kt_register_ppl_stepper",
  ref: "horizontalWizardRef"
}
const _hoisted_11 = { class: "stepper-nav py-5 mt-5" }
const _hoisted_12 = {
  class: "stepper-item current",
  "data-kt-stepper-element": "nav"
}
const _hoisted_13 = {
  key: 0,
  class: "stepper-title"
}
const _hoisted_14 = {
  key: 1,
  class: "stepper-title"
}
const _hoisted_15 = {
  class: "stepper-item",
  "data-kt-stepper-element": "nav"
}
const _hoisted_16 = {
  key: 0,
  class: "stepper-title"
}
const _hoisted_17 = {
  key: 1,
  class: "stepper-title"
}
const _hoisted_18 = {
  key: 0,
  class: "stepper-item",
  "data-kt-stepper-element": "nav"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h3", { class: "stepper-title" }, "Verificación ingresos anteriores", -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = {
  class: "stepper-item",
  "data-kt-stepper-element": "nav"
}
const _hoisted_22 = {
  key: 0,
  class: "stepper-title"
}
const _hoisted_23 = {
  key: 1,
  class: "stepper-title"
}
const _hoisted_24 = {
  class: "stepper-item",
  "data-kt-stepper-element": "nav"
}
const _hoisted_25 = {
  key: 0,
  class: "stepper-title"
}
const _hoisted_26 = {
  key: 1,
  class: "stepper-title"
}
const _hoisted_27 = {
  class: "stepper-item",
  "data-kt-stepper-element": "nav"
}
const _hoisted_28 = {
  key: 0,
  class: "stepper-title"
}
const _hoisted_29 = {
  key: 1,
  class: "stepper-title"
}
const _hoisted_30 = {
  class: "stepper-item",
  "data-kt-stepper-element": "nav"
}
const _hoisted_31 = {
  key: 0,
  class: "stepper-title"
}
const _hoisted_32 = {
  key: 1,
  class: "stepper-title"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", {
  class: "stepper-item",
  "data-kt-stepper-element": "nav"
}, [
  /*#__PURE__*/_createElementVNode("h3", { class: "stepper-title" }, "Confirmación")
], -1)
const _hoisted_34 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_35 = { "data-kt-stepper-element": "content" }
const _hoisted_36 = {
  key: 0,
  "data-kt-stepper-element": "content"
}
const _hoisted_37 = { "data-kt-stepper-element": "content" }
const _hoisted_38 = { "data-kt-stepper-element": "content" }
const _hoisted_39 = { "data-kt-stepper-element": "content" }
const _hoisted_40 = { "data-kt-stepper-element": "content" }
const _hoisted_41 = { "data-kt-stepper-element": "content" }
const _hoisted_42 = { class: "d-flex flex-stack pt-15" }
const _hoisted_43 = { class: "mr-2" }
const _hoisted_44 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_45 = /*#__PURE__*/_createTextVNode(" Atrás ")
const _hoisted_46 = ["disabled"]
const _hoisted_47 = { class: "indicator-label" }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { key: 1 }
const _hoisted_50 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_51 = ["disabled"]
const _hoisted_52 = { class: "indicator-label" }
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { key: 1 }
const _hoisted_55 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_56 = /*#__PURE__*/_createTextVNode(" Verificar ")
const _hoisted_57 = { class: "svg-icon svg-icon-4 ms-1 me-0" }
const _hoisted_58 = {
  key: 3,
  type: "submit",
  class: "btn btn-lg btn-success"
}
const _hoisted_59 = /*#__PURE__*/_createTextVNode(" Continuar ")
const _hoisted_60 = { class: "svg-icon svg-icon-4 ms-1 me-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_court_order = _resolveComponent("court-order")!
  const _component_person_data = _resolveComponent("person-data")!
  const _component_check_re_entry = _resolveComponent("check-re-entry")!
  const _component_general_data = _resolveComponent("general-data")!
  const _component_family_data = _resolveComponent("family-data")!
  const _component_desease_data = _resolveComponent("desease-data")!
  const _component_pictures_data = _resolveComponent("pictures-data")!
  const _component_confirmation_send = _resolveComponent("confirmation-send")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.personDetails === '0')
          ? (_openBlock(), _createElementBlock("h2", _hoisted_4, " Registro de Privado de Libertad "))
          : (_openBlock(), _createElementBlock("h2", _hoisted_5, " Edición de registro del Privado de Libertad ")),
        _createElementVNode("p", _hoisted_6, [
          (_ctx.personDetails === '0')
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Obtención de datos del privado de libertad."))
            : (_openBlock(), _createElementBlock("span", _hoisted_8, "Edición de datos del privado de libertad."))
        ]),
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              (_ctx.personDetails === '0')
                ? (_openBlock(), _createElementBlock("h3", _hoisted_13, " Registro orden judicial "))
                : (_openBlock(), _createElementBlock("h3", _hoisted_14, "Edición orden judicial"))
            ]),
            _createElementVNode("div", _hoisted_15, [
              (_ctx.personDetails === '0')
                ? (_openBlock(), _createElementBlock("h3", _hoisted_16, " Datos de la persona "))
                : (_openBlock(), _createElementBlock("h3", _hoisted_17, "Edición datos de la persona"))
            ]),
            (_ctx.personDetails === '0')
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_21, [
              (_ctx.personDetails === '0')
                ? (_openBlock(), _createElementBlock("h3", _hoisted_22, " PPL datos generales "))
                : (_openBlock(), _createElementBlock("h3", _hoisted_23, "Edición PPL datos generales"))
            ]),
            _createElementVNode("div", _hoisted_24, [
              (_ctx.personDetails === '0')
                ? (_openBlock(), _createElementBlock("h3", _hoisted_25, " PPL familiares "))
                : (_openBlock(), _createElementBlock("h3", _hoisted_26, "Edición PPL familiares"))
            ]),
            _createElementVNode("div", _hoisted_27, [
              (_ctx.personDetails === '0')
                ? (_openBlock(), _createElementBlock("h3", _hoisted_28, " PPL enfermedades "))
                : (_openBlock(), _createElementBlock("h3", _hoisted_29, "Edición PPL enfermedades"))
            ]),
            _createElementVNode("div", _hoisted_30, [
              (_ctx.personDetails === '0')
                ? (_openBlock(), _createElementBlock("h3", _hoisted_31, " PPL fotos de perfil "))
                : (_openBlock(), _createElementBlock("h3", _hoisted_32, "Edición PPL fotos de perfil"))
            ]),
            _hoisted_33
          ]),
          _createElementVNode("form", {
            class: "mx-auto mw-100 w-100 pt-15 pb-10",
            novalidate: "novalidate",
            id: "kt_create_account_form",
            onSubmit: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleStep && _ctx.handleStep(...args)))
          }, [
            _createElementVNode("div", _hoisted_34, [
              _createVNode(_component_court_order)
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createVNode(_component_person_data)
            ]),
            (_ctx.personDetails === '0')
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  _createVNode(_component_check_re_entry)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_37, [
              _createVNode(_component_general_data)
            ]),
            _createElementVNode("div", _hoisted_38, [
              _createVNode(_component_family_data)
            ]),
            _createElementVNode("div", _hoisted_39, [
              _createVNode(_component_desease_data)
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createVNode(_component_pictures_data)
            ]),
            _createElementVNode("div", _hoisted_41, [
              _createVNode(_component_confirmation_send)
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-lg btn-secondary me-3",
                  "data-kt-stepper-action": "previous",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.previousStep && _ctx.previousStep(...args)))
                }, [
                  _createElementVNode("span", _hoisted_44, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr063.svg" })
                  ]),
                  _hoisted_45
                ])
              ]),
              _createElementVNode("div", null, [
                (
                    _ctx.currentStepIndex === _ctx.totalSteps - 1 && _ctx.personDetails === '0'
                  )
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-lg btn-primary me-3",
                      "data-kt-stepper-action": "submit",
                      disabled: _ctx.sendDelay,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.formSubmit()))
                    }, [
                      _createElementVNode("span", _hoisted_47, [
                        (!_ctx.sendDelay)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_48, "Enviar"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_49, "Por favor espera ...")),
                        _createElementVNode("span", _hoisted_50, [
                          _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                        ])
                      ])
                    ], 8, _hoisted_46))
                  : (
                    _ctx.currentStepIndex === _ctx.totalSteps - 1 && _ctx.personDetails !== '0'
                  )
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        class: "btn btn-lg btn-primary me-3",
                        "data-kt-stepper-action": "submit",
                        disabled: _ctx.sendDelay,
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.SendEdition()))
                      }, [
                        _createElementVNode("span", _hoisted_52, [
                          (!_ctx.sendDelay)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_53, "Enviar edición"))
                            : (_openBlock(), _createElementBlock("span", _hoisted_54, "Por favor espera ...")),
                          _createElementVNode("span", _hoisted_55, [
                            _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                          ])
                        ])
                      ], 8, _hoisted_51))
                    : (_ctx.currentStepIndex === 1 && _ctx.personDetails === '0')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          type: "submit",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.checkIfExist())),
                          class: "btn btn-lg btn-primary"
                        }, [
                          _hoisted_56,
                          _createElementVNode("span", _hoisted_57, [
                            _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("button", _hoisted_58, [
                          _hoisted_59,
                          _createElementVNode("span", _hoisted_60, [
                            _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                          ])
                        ]))
              ])
            ])
          ], 32)
        ], 512)
      ])
    ])
  ]))
}